import type { IndexEarningResponseSchema } from "@jti/evo-client";
import type { GetArticlesResponseType } from "@jti/rest-api-types";

export const getArticlesFromEvoPayload = (data: IndexEarningResponseSchema[] = []): GetArticlesResponseType => {
  return data.map((item) => {
    return {
      article_type: item.type,
      article_id: item.identifier,
      value: item.points_without_multiply,
      is_read: item.is_read || false,
      is_watched: item.is_watched || false,
      is_completed: item.is_completed || false,
      is_available: item.is_available,
      levels: item.levels,
    };
  });
};
